// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable length-zero-no-unit */
.LumeTheme__overlay___15lKd {
  --_apc-modal-overlay-background-color-lume: rgba(255, 255, 255, 0.76);
}
.LumeTheme__modal___3H3BK {
  --_apc-modal-border-radius-lume: var(--lume-g-radius-border-3);
  --_apc-modal-border-lume: 1px solid var(--lume-g-color-border-primary);
  --_apc-modal-box-shadow-lume: var(--lume-g-shadow-level-5);
  --_apc-modal-color: var(--lume-g-color-text-primary);
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/components/Modal/themes/LumeTheme.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,qEAAqE;AACvE;AACA;EACE,8DAA8D;EAC9D,sEAAsE;EACtE,0DAA0D;EAC1D,oDAAoD;AACtD","sourcesContent":["/* stylelint-disable length-zero-no-unit */\n.LumeTheme__overlay___15lKd {\n  --_apc-modal-overlay-background-color-lume: rgba(255, 255, 255, 0.76);\n}\n.LumeTheme__modal___3H3BK {\n  --_apc-modal-border-radius-lume: var(--lume-g-radius-border-3);\n  --_apc-modal-border-lume: 1px solid var(--lume-g-color-border-primary);\n  --_apc-modal-box-shadow-lume: var(--lume-g-shadow-level-5);\n  --_apc-modal-color: var(--lume-g-color-text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
